export interface FilterFieldMetadata {
  type: 'number' | 'date' | 'select' | 'string';
  min?: string | number | null;
  max?: string | number | null;
  values?: string[];
}

export const toDateInputValue = (value?: string | number | null): string => {
  if (value == null || value === '') {
    return '';
  }
  const text = String(value);
  return text.length >= 10 ? text.slice(0, 10) : text;
};

export const isFilterValueActive = (value: any): boolean => {
  if (value == null || value === '') {
    return false;
  }
  if (typeof value === 'object') {
    const minOrStart = value.min ?? value.start;
    const maxOrEnd = value.max ?? value.end;
    const hasMin = minOrStart != null && minOrStart !== '';
    const hasMax = maxOrEnd != null && maxOrEnd !== '';
    if ('start' in value || 'end' in value) {
      return hasMin && hasMax;
    }
    return hasMin || hasMax;
  }
  return true;
};

export const hasAtLeastOneFilter = (filters: Record<string, any>): boolean => {
  return Object.values(filters).some(isFilterValueActive);
};

export const optionsFromValues = (values?: string[]) =>
  (values || [])
    .filter((value) => value != null && value !== '')
    .map((value) => ({ value, label: value }));

export const formatFilterChipLabel = (label: string, value: any): string => {
  if (value == null || value === '') {
    return label;
  }
  if (typeof value === 'object') {
    const start = value.start ?? value.min;
    const end = value.end ?? value.max;
    if (start && end) {
      return `${label}: ${start} – ${end}`;
    }
    if (start) {
      return `${label}: from ${start}`;
    }
    if (end) {
      return `${label}: to ${end}`;
    }
    return label;
  }
  return `${label}: ${value}`;
};
